<template>
  <div class="add-mt5-check-password">
    <Header :title="title" />
    <div class="content">
      <div class="description">为账户安全，开立 MT5 账号前请输入目前密码确认</div>
      <div class="item">
        <span>密码</span>
        <div class="input-box" :class="password!=''?'border':''">
          <input v-model="password" :type="[showPwd?'text':'password']" placeholder="请输入密码" style="width: 90%;">
          <img v-if="showPwd" class="icon" src="@/assets/images/login/open-code.png" alt="" @click="togglePwd()">
          <img v-else class="icon" src="@/assets/images/login/close-code.png" alt="" @click="togglePwd()">
        </div>
      </div>
      <div class="confirm-box" @click="confirm()"><span class="confirm-btn" type="primary">确认</span></div>
    </div>
    <AlertPop
      :model="showErrorPop"
      :content="errorMessage"
      :button1-txt="'知道了'"
      @alertOnClose="closeErrorPop"
    />
    <AlertPop
      :model="showGoToModifyPwdPop"
      :content="'为账户安全， 开立MT5账户需修改更高强度密码。修改成功后可以相同账号密码登录CFD和MT5平台'"
      :button1-txt="'去修改密码'"
      @button1Evt="goToModifyPwd"
    />
    <AddMT5
      :execute="executeAddMT5"
      :logout="true"
      @onSuccess="onAddMT5Success"
    />
    <Chat />
  </div>
</template>

<script>
require('@/assets/css/addMT5CheckPassword.css')
import Header from '@/view/module/Header.vue'
import AlertPop from '@/view/module/AlertPop.vue'
import api from '@/plugins/api'
import { mapState } from 'vuex'
import Chat from '@/view/module/Chat.vue'
import AddMT5 from '@/view/addMT5/AddMT5.vue'

export default {
  name: 'AddMT5CheckPassword',
  components: { Header, AlertPop, Chat, AddMT5 },
  computed: {
    ...mapState([
      'accountNo'
    ])
  },
  data() {
    return {
      title: '开立 MT5 账号',
      password: '',
      showPwd: false,
      showErrorPop: false,
      errorMessage: '',
      showGoToModifyPwdPop: false,
      executeAddMT5: false
    }
  },
  methods: {
    togglePwd() {
      this.showPwd = !this.showPwd
    },
    confirm() {
      const param = {
        customerNumber: this.accountNo,
        password: this.password
      }

      this.$bus.$emit('loading', false)
      api.login(this.$qs.stringify(param)).then(res => {
        if (res.status) {
          if (res.data.code == 200) {
            if (!this.isValidPassword()) {
              this.$bus.$emit('loading', true)
              this.showGoToModifyPwdPop = true
              return
            }
            this.executeAddMT5 = true
          } else {
            this.$bus.$emit('loading', true)
            this.showErrorPop = true
            this.errorMessage = res.data.code_desc
          }
        } else {
          this.$bus.$emit('loading', true)
          this.showErrorPop = true
          this.errorMessage = res.data.code_desc
        }
      })
    },
    isValidPassword() {
      return (/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[-_.~{};':"\\|,.<>\/?])[A-Za-z\d-_.~{};':"\\|,.<>\/?]{8,16}$/).test(this.password)
    },
    goToModifyPwd() {
      this.showGoToModifyPwdPop = false
      this.$router.push({ path: '/home/modifyPwd', query: { addMT5: '1' }})
    },
    closeErrorPop() {
      this.showErrorPop = false
      this.errorMessage = ''
    },
    onAddMT5Success() {
      this.$router.replace({ path: '/addMT5Result', query: { accountNo: this.accountNo }})
    }
  }
}
</script>
